export enum RoleEnum {
    Student = "student",
    Company = "company",
    Admin = "admin",
    School = "school",
    Tutor = "tutor",
}